// import Vue from 'vue/dist/vue.esm.js';
import { tns } from 'tiny-slider/src/tiny-slider'

let timeout;

export default {
    init() {
    },
    finalize() {
        onExpandMenuItems()
        onExpandMenu()
        $( window ).resize(onWindowResize)
        onClickSidebarTitle()
        initSlider()
    },
};

const initSlider = () => {
    tns({
        container: '.header__banner__items',
        autoplay: true,
        autoplayButtonOutput: false,
        slideCount: false,
        controls: false,
        items: 1,
        nav: false,
        arrowKeys: false,
        autoplayTimeout: 5000,
        responsive: {
            501: { items: 2 },
            768: { disable: true },
        },
    });
}
const onClickSidebarTitle = () => {
    $('.sidebar h3').click((e) => $(e.target).siblings('ul').slideToggle())
}

const onWindowResize = () => {
    // debounce
	timeout && window.cancelAnimationFrame(timeout);

	timeout = window.requestAnimationFrame(function () {
        $('#header-menu-mobile').hide()
	});
}
const onExpandMenu = () => {
    $('.js__expand-menu').on('click', () => $('#header-menu-mobile').slideToggle())
}
const onExpandMenuItems = () => {
    $('.js__expand-sub-menu').on('click', (e) => $(e.currentTarget).siblings('ul').slideToggle())
}



// WEBPACK FOOTER //
// ./scripts/routes/common.js